/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import AvailableOn from './AvailableOn';
import FormOption from '../../../../_components/Options/FormOption';
import LocationOption from '../../../../_components/Options/LocationOption';
import ReactDatePicker from '../../../../_components/DatePicker/ReactDatePicker';
import ProfessionalOption from '../../../../_components/Options/ProfessionalOption';
import RenderValidateMessage from '../../../../stories/Validation/RenderValidateMessage';

import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function AddFormModal(
  {
    show,
    hide,
    loading = false,
    addEventItem,
    formSelected = "",
    groupSelected = "",
    completeByDate = "",
    providerSelected = "",
  }
) {

  const [form, setForm] = useState(formSelected);
  const [errors, setErrors] = useState({});
  const [doctor, setDoctor] = useState(providerSelected);
  const [completeBy, setCompleteBy] = useState("");
  const [availableOn, setAvailableOn] = useState("");
  const [providerGroup, setProviderGroup] = useState(groupSelected);

  useEffect(() => {
    handleShow();
  }, [show])

  const handleShow = () => {
    setForm(formSelected);
    setErrors({});
    setDoctor(providerSelected);
    setCompleteBy("");
    setAvailableOn("");
    setProviderGroup(groupSelected);
  }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!completeBy) {
      errors.dateTime = 'Complete By Date is required.'
    } else if (moment(completeBy).isBefore(new Date())) {
      errors.dateTime = 'Complete By Date must be upcoming.';
    }

    if (!providerGroup.value) {
      errors.providerGroup = 'Location is required.'
    }

    if (!doctor.value) {
      errors.doctor = 'Provider is required.'
    }

    if (!form.value) {
      errors.questions = 'Form is required.'
    }

    if (availableOn && moment(availableOn).isSameOrBefore(moment())) {
      errors.availableOn = 'Available On must be an upcoming date.';
    }

    if (availableOn && completeBy && moment(availableOn).isSameOrAfter(moment(completeBy))) {
      errors.availableOn = 'Available On must be before appointment date.';
    }

    setErrors(errors);

    if (!errors.dateTime && !errors.doctor && !errors.providerGroup && !errors.questions && !errors.availableOn) {
      addForm();
    }
  }

  const addForm = () => {
    const formItem = {
      type: "Form",
      form: { id: form.value, name: form.label },
      doctor: { id: doctor.value, name: doctor.label },
      date: moment(completeBy).format("LLL"),
      availableOn: availableOn ? moment(availableOn).format("LLL") : 'Immediately',
      providerGroup: { id: providerGroup.value, name: providerGroup.label },
    }
    addEventItem(formItem);
    clearAndHideForm();
  }

  const clearAndHideForm = () => {
    setErrors({});
    setForm("");
    setDoctor("");
    setCompleteBy("");
    setAvailableOn("");
    setProviderGroup("");
    hide();
  }

  return (
    <Modal show={show} onHide={clearAndHideForm}>
      <Modal.Header closeButton>
        <Modal.Title>Add Form</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="form-providerGroup mb-4">
            <div className="row">
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Provider</label>
                <ProfessionalOption defaultValue={doctor.value} handleSelected={(value, label) => setDoctor({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="doctor" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Location</label>
                <LocationOption defaultValue={providerGroup.value} handleSelected={(value, label) => setProviderGroup({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="providerGroup" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Form</label>
                <FormOption defaultValue={form.value} handleSelected={(value, label) => setForm({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="questions" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Complete By Date</label>
                <ReactDatePicker
                  selected={completeBy}
                  onChange={(date) => setCompleteBy(date)}
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={5}
                  dateFormat="MMM d, yyyy h:mm aa"
                  className="form-control"
                  wrapperClassName="w-100"
                />
                <RenderValidateMessage errors={errors} field="dateTime" />
              </div>
              <div className="col-sm-12">
                <AvailableOn
                  sendOn={availableOn}
                  noMinTime={true}
                  noMaxTime={true}
                  setAvailableOn={(date) => setAvailableOn(date)}
                  apptDate={completeBy}
                  apptType="form"
                />
                <RenderValidateMessage errors={errors} field="availableOn" />
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={validate} disabled={loading}>
          {loading ? 'Adding...' : 'Add Form'}
        </Button>
        <Button variant="secondary" onClick={clearAndHideForm}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
